import { emitLog } from '../config/posthogLogs';

export function setupErrorLogging() {
  // Uncaught JS errors
  window.addEventListener('error', (event) => {
    emitLog({
      severityText: 'error',
      body: event.message || 'Unknown error',
      attributes: {
        'error.type': 'uncaught_error',
        'error.filename': event.filename || '',
        'error.lineno': event.lineno || 0,
        'error.colno': event.colno || 0,
        'error.stack': event.error?.stack || '',
      },
    });
  });

  // Unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message =
      reason instanceof Error ? reason.message : String(reason || 'Unknown rejection');
    const stack = reason instanceof Error ? reason.stack : '';

    emitLog({
      severityText: 'error',
      body: message,
      attributes: {
        'error.type': 'unhandled_rejection',
        'error.stack': stack || '',
      },
    });
  });

  // Intercept console.error
  const originalConsoleError = console.error;
  console.error = (...args) => {
    originalConsoleError.apply(console, args);

    const body = args
      .map((arg) => {
        if (arg instanceof Error) return arg.message;
        if (typeof arg === 'string') return arg;
        try {
          return JSON.stringify(arg);
        } catch {
          return String(arg);
        }
      })
      .join(' ');

    emitLog({
      severityText: 'error',
      body,
      attributes: {
        'error.type': 'console_error',
      },
    });
  };
}
